import React from "react";
import {
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import { Grid, CircularProgress } from "@material-ui/core";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// provider
import { useLayout } from  "../../providers/App/Layout/LayoutProvider";

// pages
const CancellationCreate = React.lazy(() => import("../../pages/cancellations/Create"));
const CancellationView = React.lazy(() => import("../../pages/cancellations/View"));
const RefundCreate = React.lazy(() => import("../../pages/refunds/Create"));
const Confirmation = React.lazy(() => import("../../pages/confirmation/Confirmation"));
const BulkCancel = React.lazy(() => import("../../pages/cancellations/BulkCancel"));

function Layout({history}) {

  // global
  const { sidebarState } = useLayout();

  const classes = useStyles();

  return (
    <div className={classes.root}>
        <>
          <Header history={history} />
          <Sidebar />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: sidebarState.isSidebarOpened,
            })}
          >
            <div className={classes.fakeToolbar} />
            <Switch>
              <React.Suspense fallback={<CircularProgress />}>
                <Route path="/app/cancellations/create/:orderID?" component={CancellationCreate} />
                <Route path="/app/cancellations/view/:orderID?" component={CancellationView} />
                <Route path="/app/refunds/create" component={RefundCreate} />
                <Route path="/app/confirmation/:cancellationID" component={Confirmation} />
                <Route path="/app/cancellations/bulkcancel" component={BulkCancel} />
              </React.Suspense>
            </Switch>
          </div>
        </>
    </div>
  );
}

export default withRouter(Layout);
